import { motion } from "framer-motion";

type HotBlobLogoProps = {
  className?: string;
  to?: string;
};

const HotBlobLogo: React.FC<HotBlobLogoProps> = ({ className, to }) => {
  const logoImg = (
    <motion.img
      whileHover={{ scale: 1.15, rotate: -2 }}
      whileTap={{ scale: 0.9 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
      src={require("../assets/logo.svg").default}
      alt="logo"
      className={className}
    />
  );
  return to ? <a href={to}>{logoImg}</a> : logoImg;
};

export default HotBlobLogo;
